// i18n area 'storage' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.uk-UA.meta.json.
import type { enUS } from './storage'

export const ukUA: typeof enUS = {
  storage: {
    pools: {
      title: 'Сховища',
      createTitle: 'Створити сховище',
      path: 'Шлях',
      pathHint: 'Абсолютний шлях під дозволеним коренем (типово /var/lib/tvirt/pools/)',
      shared: 'Спільне сховище',
      sharedChip: 'спільне',
      sharedVerifiedChip: 'спільне · перевірено',
      sharedVerifiedTooltip: 'Спільність перевірено: перехресні проби підтверджують, що кожен учасник бачить дані, записані іншими.',
      sharedDisputedChip: 'спільне · НЕ перевірено',
      sharedDisputedTooltip: 'Спільність НЕ перевірено',
      sharedDisputedPair: '{observer} не бачить даних, записаних {writer}',
      sharedHint: 'Мережевий спільний ресурс, змонтований локально за тим самим шляхом на кожному учаснику — передумова живої міграції (декларативна).',
      sharedDanger: 'НЕБЕЗПЕКА — TVirt ВІРИТЬ цьому прапорцю: щойно ви його ввімкнете, кожен учасник припускає, що бачить ТІ САМІ байти за цим шляхом. На теці, яка НЕ є справді спільним ресурсом (NFS/CIFS/кластерна файлова система), результатом буде пошкодження й утрата даних при першій же міграції чи першому перезапуску HA на іншому вузлі. Вмикайте його, лише якщо шлях є спільним ресурсом, змонтованим однаково на кожному вузлі.',
      type: 'Тип',
      capacity: 'Ємність',
      provisioned: 'Виділено',
      provisionedOvercommit: 'Потенційне зобов’язання понад ємність: тонкі томи можуть вирости до {n} GiB.',
      phase: { ready: 'Готове', degraded: 'Деградоване', error: 'Помилка' },

      // Раунд #156 (стандартний діалог): ПОВНИЙ діалог деталей — вкладки,
      // рядки конфігурації для кожного драйвера і спостережена поверхня.
      tabConfig: 'Конфігурація',
      tabCapacity: 'Ємність і стан',
      cardIdentity: 'Ідентичність',
      cardPlacement: 'Розміщення',
      cardConnection: 'З’єднання',
      usedReal: 'Реальна зайнятість',
      capacityUnknown: 'Вузол ще не повідомив ємність цього пулу — тут чисел не вигадують',
      overcommitHint: 'Зобов’язання понад ємність: законне на тонких пулах, лише пильнуйте реальну зайнятість',
      supportedContent: 'Підтримуваний вміст',
      content: {
        disks: 'Диски',
        catalogFiles: 'Файли каталогу',
        backups: 'Резервні копії',
        appVolumes: 'Томи застосунків'
      },
      defaultDiskFormat: 'Типовий формат диска',
      reserveGiB: 'Зарезервований вільний простір (GiB)',
      available: 'Доступно',
      diskCount: 'Диски',
      filesystem: 'Файлова система',
      observedAt: 'Спостережено',
      lostAtRow: 'Оголошено втраченим',
      sharedProbeRow: 'Перевірка спільності',
      sharedProbeNodes: 'Опитані вузли',
      reachableFrom: 'Оголошена досяжність',
      reachableFromHint: 'Вузли, з яких це сховище має бути досяжним. ВМ із дисками, ISO чи метаданими тут не запуститься й не мігрує на вузол поза цим списком. Усі учасники обрані наперед: звужуйте як завгодно. Вузол, який приєднається до кластера згодом, лишається поза списком, доки ви не додасте його сюди.',
      reachableFromNone: 'не оголошена',
      reachableFromTags: 'Досяжність за тегами',
      reachableFromTagsHint: 'Селектор тег=значення (записи через кому, за І): кожен учасник, що несе ці теги, оголошується досяжним — динамічно: варто позначити вузол тегом, і він увійде.',
      reachableFromTagsInvalid: 'Неприпустимий формат — використовуйте тег=значення, через кому',
      reachableResolved: 'Розв’язані вузли: {nodes}',
      reachableDeclaredNotSeen: 'оголошено, але проба спільності не побачила на: {nodes}',
      reachableSeenNotDeclared: 'побачено, але не оголошено (поза периметром) на: {nodes}',
      cephCluster: 'Керований кластер Ceph',
      appGuardTitle: 'Сховище, яке використовують застосунки',
      appEphemeralGuard: 'це сховище є ефемерним пулом застосунків рівня кластера — спершу змініть його на сторінці «Застосунки», потім видаліть.',
      appInUseGuard: 'тут живуть корені й томи застосунків: {apps} — спершу перемістіть або видаліть їх.',
      releaseRequiredTitle: 'Видалити «{name}» і звільнити його образи?',
      releaseRequiredBatchTitle: 'Видалити вибрані storage і звільнити їхні образи?',
      releaseRequiredBody: 'Звільнення образів НЕ видаляє жодного байта: скасування реєстрації залишає namespace на диску, образи просто перестають бути матеріалізованими, а кожне посилання scope виживає як claim — зареєструйте pool знову, і їх буде всиновлено повторно.',
      releaseConfirm: 'Видалити й звільнити образи'
    },
    lost: {
      chip: 'Втрачене',
      action: 'Оголосити втраченим',
      confirmTitle: 'Оголосити сховище втраченим',
      confirmBody: 'Засвідчення оператора на власний оголошений ризик: кожне завдання в черзі чи в роботі над цим сховищем або його об’єктами ЗАЗНАЄ НЕВДАЧІ, видалення стають лише реєстровими (жодної роботи з файловою системою), а нова фізична робота відхиляється. Байтів ніхто ніколи не торкається — якщо том оживе, зареєструйте його знову й запустіть сканування, щоб усе прийняти назад.',
      confirmSubmit: 'Оголосити втраченим',
      error: 'Засвідчення відхилено'
    },
    findings: {
      action: 'Знайдені об’єкти',
      title: 'Знайдені об’єкти',
      empty: 'У просторі імен сховища не знайдено жодного об’єкта',
      loadError: 'Не вдалося завантажити знайдені об’єкти',
      actionError: 'Рішення відхилено',
      colKind: 'Тип',
      colObject: 'Об’єкт',
      colConflict: 'Конфлікт',
      namespaceNotice:
        "Цей каталог уже було ініціалізовано іншим сховищем: печатку ідентичності перезаписано печаткою цього сховища. Вміст НЕ чіпали — перегляньте знайдені нижче об'єкти, імпортуйте потрібні, а потім закрийте це сповіщення.",
      kind: {
        disk: 'Диск',
        catalogFile: 'Файл каталогу',
        vmMetadata: 'Метадані ВМ',
        namespace: 'Простір імен',
        foreign: 'Сторонній',
        volumeGroup: 'Група томів'
      },
      vgAdopt: {
        action: 'Прийняти групу томів',
        title: 'Прийняти групу томів',
        intro:
          'Цей пристрій уже несе групу томів з назвою TVirt, але її печатка не називає жодного зареєстрованого тут storage. Це може бути те, що попередній storage ЦЬОГО кластера залишив на LUN, — або те, що ІНШИЙ кластер TVirt залишив на LUN, який змінив власника: звідси обидва випадки виглядають однаково, і саме тому ніхто не вирішує за вас.',
        irreversible: 'Подивіться на пристрій, печатку та назву, перш ніж продовжити: прийняття не скасовується.',
        device: 'Пристрій',
        seal: 'Печатка',
        sealNone: 'немає (немає тегу tvirt.storageId)',
        renameTo: 'Буде перейменовано на',
        renameNone: 'Без перейменування: назва вже така, яку виводить цей storage',
        volumesNote:
          'Томи всередині НЕ приймаються цим жестом: наступне сканування запропонує їх по одному, як звичайні знайдені об\'єкти.'
      },
      conflictChip: 'ID уже існує',
      dismissedChip: 'Проігноровано',
      adopt: 'Прийняти',
      adoptFileTitle: 'Імпортувати в каталог',
      adoptFileHint: 'Файли існують лише всередині каталогів: виберіть каталог призначення для знайденого файлу.',
      purge: 'Видалити з диска',
      dismiss: 'Ігнорувати',
      purgeConfirmTitle: 'Видалити з диска',
      purgeConfirmBody: 'Знайдені байти {id} буде вилучено зі сховища. Операція незворотна.',
      taskStarted: 'Запущено — триває як фонове завдання',
      scan: 'Сканувати сховище',
      scanStarted: 'Сканування розпочато…',
      scanDone: 'Сканування завершено — знайдені об’єкти оновлено'
    },
    reinit: {
      action: 'Повторити ініціалізацію'
    },
    wizard: {
      addButton: 'Додати',
      title: 'Додати сховище',
      back: 'Назад',
      continue: 'Продовжити',
      selectHint: 'Виберіть протокол, щоб побачити, як TVirt його використовує.',
      roadmap: 'Дорожня карта',
      server: 'Сервер',
      export: 'Експортований шлях',
      share: 'Спільний ресурс',
      username: 'Ім’я користувача',
      password: 'Пароль',
      passwordHint: 'Лише для запису: використовується для монтування, більше ніколи не показується.',
      credential: 'Облікові дані',
      credentialManual: 'Ввести вручну',
      credentialHint: 'Запис у сховищі ключів типу «ім’я користувача й пароль» — альтернатива введенню їх тут.',
      credentialEmpty: 'У сховищі ключів немає облікових даних типу «ім’я користувача й пароль» — створіть їх у розділі «Система → Облікові дані» або введіть обліковий запис нижче.',
      options: 'Параметри монтування',
      optionsHint: 'Через кому, передаються до mount -o такими, як є.',
      portal: 'Портал',
      portalHint: 'хост[:порт] — типовий порт 3260.',
      target: 'IQN цілі',
      targetHint: 'Ім’я цілі iSCSI, починається з iqn.',
      lun: 'LUN',
      wholeLunRow: 'На дисках: це сховище називає лише таргет',
      wholeLunHint: 'Це сховище називає лише таргет: його LUN стають дисками по одному (Створити диск → прийняти цілий LUN), на таргет нічого не пишеться.',
      lunHint: 'Номер LUN на цілі — 0, якщо сумніваєтеся.',
      chapCredential: 'Облікові дані (CHAP)',
      chapCredentialHint: 'Запис у сховищі ключів типу CHAP (iSCSI), яким виконується вхід — секрет ніколи не мандрує разом зі сховищем.',
      chapNone: 'Без автентифікації',
      chapEmpty: 'У сховищі ключів немає облікових даних типу CHAP (iSCSI) — створіть їх у розділі «Система → Облікові дані». Без них вхід лишається неавтентифікованим.',
      address: 'Адреса',
      addressHint: 'Хост або IP цілі NVMe/TCP (traddr).',
      port: 'Порт',
      portHint: 'TCP-порт цілі — 4420, якщо лишити порожнім.',
      targetNqn: 'NQN цілі',
      targetNqnHint: 'NQN підсистеми на цілі, починається з nqn.',
      nsid: 'NSID',
      nsidHint: 'Ідентифікатор простору імен усередині підсистеми — 1, якщо сумніваєтеся.',
      dhchapCredential: 'Облікові дані (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Запис у сховищі ключів типу DH-HMAC-CHAP (NVMe), що використовується при з’єднанні — секрет ніколи не мандрує разом зі сховищем.',
      dhchapNone: 'Без автентифікації',
      dhchapEmpty: 'У сховищі ключів немає облікових даних типу DH-HMAC-CHAP (NVMe) — створіть їх у розділі «Система → Облікові дані». Без них з’єднання лишається неавтентифікованим.',
      monitors: 'Монітори',
      monitorsHint: 'Кінцеві точки моніторів Ceph, хост[:порт], через кому або з нового рядка — типовий порт 6789.',
      pool: 'Пул',
      poolHint: 'Пул RBD, який споживається — один образ RBD на диск.',
      fs: 'Файлова система',
      fsHint: 'Назва файлової системи CephFS (mds_namespace при монтуванні).',
      fsPath: 'Шлях усередині файлової системи',
      fsPathHint: 'Абсолютний шлях усередині файлової системи, який монтує сховище — /, якщо сумніваєтеся.',
      cephxCredential: 'Облікові дані (cephx)',
      cephxCredentialHint: 'Запис у сховищі ключів типу cephx: ім’я користувача = назва клієнта (client.…), секрет = ключ у base64. Обов’язковий.',
      cephxNone: 'У сховищі ключів немає облікових даних cephx — створіть їх (тип: cephx) у розділі «Система → Облікові дані» або дозвольте керованому кластеру Ceph викарбувати їх дією «Запропонувати як сховище».',
      sharedByNature: 'Мережеві сховища спільні за природою: кожен учасник монтує їх за тим самим шляхом, яким керує TVirt.',
      error: 'Сховище відхилено',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Інше',
        legacy: 'Застарілі'
      },
      legacyHint: 'Підтримуються повноцінно — просто ми б не обирали їх для нової інсталяції.',
      proto: {
        // Рядок `usage` (Luca 2026-07-24) каже, як TVirt використовує протокол —
        // насамперед який вміст дозволено: dir/nfs/cifs тримають диски І образи
        // ISO/дисків та шаблони, блокові драйвери (iscsi/nvme-tcp/rbd) —
        // ЛИШЕ диски.
        dir: {
          name: 'Локальна тека',
          desc: 'Директорія вузла: просто і швидко. Вона ЛОКАЛЬНА для одного вузла, хіба що шлях є справді спільним ресурсом — позначити його спільним, коли це не так, коштує даних.',
          usage: 'TVirt тримає тут диски ВМ, образи ISO та дисків і шаблони.'
        },
        nfs: {
          name: 'NFS',
          desc: 'Експорт NFS, змонтований кластером — спільний за природою.',
          usage: 'Тримає диски ВМ, образи ISO та дисків і шаблони.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Спільний ресурс Windows/Samba, змонтований кластером — спільний за природою.',
          usage: 'Тримає диски ВМ, образи ISO та дисків і шаблони.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Віддалена файлова система через SSH — без потреби в експорті NAS.',
          usage: 'У дорожній карті.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Блокові LUN через IP зі спільним LVM зверху.',
          usage: 'Лише диски — один тонкий том на диск; не тримає ні образів ISO, ні шаблонів.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Блокові пристрої, розподілені по кластеру Ceph.',
          usage: 'Лише диски — один образ RBD на диск, який QEMU відкриває нативно; не тримає образів ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Розподілена файлова система Ceph, змонтована ядром на кластері — спільна за природою.',
          usage: 'Тримає диски ВМ, образи ISO та дисків і шаблони — родина dir поверх файлової системи Ceph (облікові дані cephx обов’язкові).'
        },
        fc: { name: 'SCSI/FC', desc: 'LUN SCSI на фабриці FibreChannel — класична SAN на FC.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'Той самий SCSI поверх FibreChannel, з кадрами FC, інкапсульованими в Ethernet.' },

        // Живе з раунду #132 — ключем є назва драйвера з контракту, тож чип у
        // списку сховищ розв’язує той самий запис.
        'iscsi-lun': {
          name: 'iSCSI (цілі LUN)',
          desc: 'iSCSI-таргет як носій цілих LUN: кожен диск — ЦЕ LUN, переданий гостю як є — без LVM посередині.',
          usage: 'Лише диски — один цілий LUN на диск, прийнятий як є; SAN-дім дисків зі спільним записом.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (цілі namespace)',
          desc: 'NVMe-підсистема як носій цілих namespace: кожен диск — ЦЕ namespace, переданий гостю як є.',
          usage: 'Лише диски — один цілий namespace на диск, прийнятий як є; спільний запис — так, SCSI persistent reservations — ні.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Віддалений NVMe — жодного SCSI на шляху — поверх простого TCP, зі спільним LVM зверху.',
          usage: 'Лише диски — один тонкий том на диск; не тримає ні образів ISO, ні шаблонів.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Віддалений NVMe на фабриці FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe на фабриці FibreChannel, яку FCoE переносить усередині Ethernet — шари FCoE і NVMe/FC, накладені один на одного.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI з перенесеним на RDMA шляхом даних — будь-яка фабрика (InfiniBand, iWARP, RoCE). Витіснений NVMe/RDMA, досі присутній у масивах і в ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Нативний SCSI поверх RDMA, доба до iSER: InfiniBand (з виявленням фабрики) і RoCE — виживає у старих сховищах HPC.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Віддалений NVMe на будь-якій фабриці RDMA — InfiniBand, iWARP, RoCE v1 і v2: одна-єдина конфігурація, а яка саме — каже вузол.' },
        s3: { name: 'S3', desc: 'Об’єктне сховище, сумісне з S3 — образи та резервні копії.' }
      }
    },
    catalogs: {
      title: 'Каталоги',
      createTitle: 'Створити каталог',
      editTitle: 'Редагувати каталог',
      docTitle: 'Каталог',
      notFound: 'Цього каталогу не існує (вже?)',
      scopeHint: 'Хто читає цей скоуп, бачить (і може використовувати) кожен файл каталогу',
      files: 'Файли',
      noFiles: 'Немає файлів',
      count: {
        iso: 'ISO',
        ctRootfs: 'Шабл. CT',
        vmTemplate: 'Шабл. ВМ',
        ociImage: 'OCI',
        firmwareOvmf: 'Прошивка'
      },

      // Системний каталог (раунд #126): домівка вбудованих об’єктів платформи —
      // читає кожен, не пише ніхто.
      systemChip: 'системний',
      systemTooltip: 'Системний каталог: тримає вбудовані об’єкти платформи, і його не можна змінювати'
    },

    // Файли каталогу (раунд K1, inventory v2e/v2g): каталог — це домівка
    // файлових артефактів кластера: один список, заголовки за kind.
    catalogFiles: {
      catalog: 'Каталог',
      kindLabel: 'Тип',
      physicalSize: 'Фізичний розмір',
      virtualSize: 'Віртуальний розмір',

      // Раунд K3 (#64) + K4 (#65, ova/ovf з відображенням boot-survival):
      // матеріалізує файл vm-template як шаблон ВМ в інвентарі.
      importTemplateAction: 'Імпортувати як шаблон ВМ',
      importTemplateLegacy: 'Формат не оголошено — придатний як основа для дисків, не імпортується',
      importTemplateTitle: 'Імпортувати як шаблон ВМ',
      importTemplateSubmit: 'Імпортувати',
      importTemplateError: 'Імпорт не вдався',
      importTemplateHint: 'Пакет .tvtpl стає шаблоном ВМ: заморожене обладнання з маніфеста плюс один диск на кожен запис архіву, кожен звірений зі своєю контрольною сумою. NIC і носії CD/DVD не входять до архіву — додайте їх після імпорту.',
      importTemplateQcow2Hint: 'Голий qcow2 стає ОДНОдисковим шаблоном з оголошеним типовим обладнанням: профіль linux, UEFI, 2 vCPU, 2048 MiB, завантаження з його єдиного диска. Виправите при розгортанні.',
      importTemplateName: 'Назва шаблона',
      importTemplateNameHint: 'Порожньо = {name} (-import-<n>, якщо зайнято)',
      importTemplateStorage: 'Сховище для дисків',
      importTemplateMetadataStorage: 'Сховище метаданих',
      importTemplateMetadataHint: 'Блокове сховище не тримає метаданих ВМ (прошивка, varstore) — виберіть dir/nfs/cifs.',
      importTemplateStarted: 'Імпорт розпочато — шаблон з’явиться на вкладці «Шаблони», щойно завдання закриється.',

      // Промовисті мітки в однині (#86): знахідки й перепис кажуть, ЧИМ є файл —
      // загальне «Файл каталогу» лишається лише запасним варіантом.
      kind: {
        iso: 'Образ ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Шаблон ВМ',
        'oci-image': 'Образ OCI',
        'firmware-ovmf': 'Прошивка OVMF'
      },
      title: {
        iso: 'Образи ISO',
        'ct-rootfs': 'Шаблони CT',
        'vm-template': 'Шаблони ВМ',
        'oci-image': 'Образи OCI',
        'firmware-ovmf': 'Прошивки OVMF'
      },
      createTitle: {
        iso: 'Додати образ ISO',
        'ct-rootfs': 'Зареєструвати шаблон CT',
        'vm-template': 'Додати шаблон ВМ',
        'oci-image': 'Додати образ OCI',
        'firmware-ovmf': 'Додати прошивку OVMF'
      },
      formatHint: 'Виведено з розширення вибраного файлу — виправте, якщо здогадка хибна',
      tarballHint: 'Тарбол rootfs у стандартному форматі LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2 або простий .tar)',
      ociArchiveHint: 'Тарбол docker-archive / oci-archive (.tar або .tar.gz), наприклад із docker save',
      uploadResumeHint: 'Вивантаження перервано — файл чекає на вивантаження: надішліть той самий файл ще раз, щоб продовжити',
      moveTitle: 'Перемістити файл',
      moveHint: 'Два незалежні виміри: Каталог переміщує посилання (той самий id, жоден байт не рухається, scope стає scope каталогу призначення); Сховище переміщує дані — кожна пов’язана копія прямує за ними, відхиляється, доки файл використовується. Обрані разом: спочатку каталог, потім сховище.',
      moveCatalog: 'Каталог призначення',
      moveCatalogHint: 'Дім змінює лише посилання: VM, що змонтувала файл, має бачити каталог призначення',
      keepCurrent: 'Не змінювати',
      rehomed: 'Посилання переміщено до обраного каталогу',
      copyAction: 'Копіювати в каталог…',
      copyTitle: 'Копіювати в каталог',
      copyLinkHint: 'Копія — це нове посилання на ті самі дані; у сховищі нічого не дублюється.',
      copyCatalog: 'Каталог призначення',
      copyCatalogHint: 'Копіювання — це спосіб, у який файл мандрує між каталогами',
      sameCatalog: 'Той самий, що й у джерела',
      sharedObjectHint: 'Дані цього файлу спільні для {count} пов’язаних копій',
      deleteLastLink: 'Це ОСТАННЄ посилання на цей вміст: разом із ним зі сховища зникнуть і дані.',
      deleteLinkOnly: 'Буде вилучено лише це посилання — дані залишаються, досі досяжні з інших пов’язаних копій ({count}).',
      noCatalog: 'Немає жодного каталогу — створіть його',
      inlineCatalogName: 'Назва каталогу',

      // Файли, вбудовані в платформу (раунд #126): сховище null — їх читають і
      // клонують, ніколи не переміщують, не видаляють і не перейменовують.
      embeddedChip: 'вбудований',
      embeddedStorage: 'Вбудований у платформу',
      embeddedNoMove: 'Вбудований файл платформи: не живе в жодному сховищі — натомість клонуйте його',
      embeddedCopyHint: 'Клон матеріалізує вбудовані байти у справжньому сховищі: виберіть сховище й каталог призначення — копія буде звичайним файлом',
      sourceEmbedded: 'Вбудований у платформу',
      nodesRow: 'Наявність на вузлах',
      nodesSummary: '{present} з {total} вузлів мають його',
      nodePresent: 'є',
      nodeMissing: 'відсутній',
      nodeUnknown: 'ще не повідомлено',
      nodesHint: 'Ресурс живе на диску кожного вузла (пакет trantor-tvirt-assets): вузол без нього не може ні визначити VM з цією прошивкою, ні надати Guest Tools. Різні версії на вузлах — норма під час поетапного оновлення.',

      // Завантаження (раунд #108): байти мандрують зі своїм окремим дозволом.
      downloadAction: 'Завантажити',
      downloadNotReady: 'Вміст ще не готовий — завантаження потребує готового файлу',
      downloadDenied: 'Ваша роль не містить catalog.download — завантаження байтів є правом, окремим від використання файлу',

      // Раунд #156 (стандартний діалог): рядки читання, яких бракувало діалогу
      // деталей — факти про спільний об’єкт, оголошена контрольна сума,
      // споживачі.
      objectRow: 'Об’єкт сховища',
      objectLinksRow: 'Пов’язані копії',
      declaredChecksum: 'Оголошений SHA-256',
      usedByRow: 'Використовується',
      usedByVms: 'ВМ',
      usedByDisks: 'Диски',
      transferRow: 'Передавання',
      storageLockHint: 'Змінюється лише дією «Перемістити»'
    },

    // Перепис по кожному сховищу (раунд K1, inventory v2b #2): лише читання,
    // кожен об’єкт керується у своєму розділі.
    objects: {
      action: 'Переглянути вміст',
      title: 'Вміст сховища',
      hint: 'Перепис лише для читання того, що живе в цьому сховищі — кожен об’єкт керується у своєму розділі.',
      empty: 'У цьому сховищі не зареєстровано жодного об’єкта',
      loadError: 'Не вдалося завантажити вміст',
      colDetail: 'Деталі',
      manage: 'Керувати у своєму розділі',
      kind: {
        disk: 'Диск',
        catalogFile: 'Файл каталогу',
        ociBlob: 'Блоб OCI',
        checkpoint: 'Контрольна точка',
        vmMetadata: 'Метадані ВМ',
        appRoot: 'Корінь застосунку',
        appVolume: 'Том застосунку'
      }
    },
    inventory: {
      tabCatalogs: 'Каталоги',
      storage: 'Сховище',
      sizeGib: 'Розмір (GiB)',
      format: 'Формат',
      size: 'Розмір',
      sourceType: 'Джерело',
      sourceFile: 'Вивантаження файлу',
      sourceUrl: 'Завантаження з URL',
      file: 'Файл',
      url: 'URL',
      checksum: 'Контрольна сума SHA-256',
      checksumHint: 'Обов’язково: завантаження звіряється з цим SHA-256',
      verifyChecksum: 'Перевіряти контрольну суму',
      checksumOffHint: 'Завантаження буде прийнято без перевірки — обчислений SHA-256 усе одно записується',
      uploading: 'Вивантаження…',
      move: {
        action: 'Перемістити',
        diskTitle: 'Перемістити диск',
        target: 'Сховище призначення',
        diskHint: 'Диск зберігає свою ідентичність: байти мандрують у вибране сховище. ВМ, яка його використовує, має бути вимкнена; за наявності знімків сторона iSCSI відмовляє в переміщенні.',
        noTargets: 'Немає сумісного сховища призначення',
        submit: 'Перемістити',
        error: 'Переміщення відхилено'
      },
      clone: {
        action: 'Клонувати',
        title: 'Клонувати диск',
        name: 'Назва копії',
        storage: 'Сховище призначення',
        sameStorage: 'Те саме, що й у джерела',
        linked: 'Пов’язаний клон',
        linkedHint: 'Миттєвий оверлей qcow2, прикутий до диска-джерела (лише джерела qcow2). Типово робиться повна копія.',
        linkedCrossHint: 'Пов’язаний клон лишається у сховищі джерела: виберіть «Те саме, що й у джерела», щоб його увімкнути.',
        submit: 'Клонувати',
        error: 'Клонування відхилено'
      },
      copy: {
        action: 'Копіювати',
        name: 'Назва копії',
        storage: 'Сховище призначення',
        sameStorage: 'Те саме, що й у джерела',
        submit: 'Копіювати',
        error: 'Копіювання відхилено'
      },
      taskStarted: 'Запущено — триває як фонове завдання',
      cephObjects: 'Перейти до деталей об’єкта в Ceph',
      phase: {
        ready: 'Готовий',
        creating: 'Створюється',
        'awaiting-upload': 'Очікує вивантаження',
        downloading: 'Завантажується',
        verifying: 'Перевіряється',
        deleting: 'Видаляється',
        error: 'Помилка',
        'in-use': 'Використовується'
      }
    }
  }
}
